/**
 * Small primary-colored dot that marks a list card as unread. Decorative: the
 * card exposes "Unread, " in its accessible name instead. `dataSlot` lets each
 * list keep its own test hook.
 */
export function UnreadIndicator({ dataSlot }: { dataSlot: string }) {
  return (
    <span
      aria-hidden
      className="size-(--spacing-6) shrink-0 rounded-full bg-primary"
      data-slot={dataSlot}
    />
  );
}
